import { render, staticRenderFns } from "./PeopleQuestionView.vue?vue&type=template&id=3ba2edd4"
import script from "./PeopleQuestionView.vue?vue&type=script&lang=js"
export * from "./PeopleQuestionView.vue?vue&type=script&lang=js"
import style0 from "./PeopleQuestionView.vue?vue&type=style&index=0&id=3ba2edd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports